/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Title_PlanInputs */

const en_title_plan = /** @type {(inputs: Title_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const de_title_plan = /** @type {(inputs: Title_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Title_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const title_plan = /** @type {((inputs?: Title_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Title_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_title_plan(inputs)
	return en_title_plan(inputs)
});